export default "__VITE_ASSET__Xgby7NaV__"